// src/data/mockData.js

// --- NEW: Mock Roles ---
export const mockRoles = [
  { id: 2, name: 'System User' },
  // { id: 4, name: 'Administrator' },
  { id: 5, name: 'Manager' },
  { id: 6, name: 'Case Manager/Cre' },
  // { id: 'r4', name: 'USER' },
];